import { Box, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import TextSectionWrapper from "./TextSectionWrapper";
import { Service } from "../types";
import { DefaultComponentProps } from "@mui/material/OverridableComponent";
import { StackTypeMap } from "@mui/system";

interface ServicesTextSectionProps
  extends DefaultComponentProps<StackTypeMap<{}, "div">> {
  service: Service;
  addSpacing?: boolean;
}

const ServicesTextSection: React.FC<ServicesTextSectionProps> = ({
  service,
  addSpacing = false,
  ...props
}) => {
  const { customSpacing } = useTheme();

  return (
    <TextSectionWrapper addSpacing={addSpacing} {...props}>
      <Box flex={1}>
        <Typography variant="subtitle1">{service.title}</Typography>
        <Typography
          variant="body1"
          maxWidth={customSpacing?.bodyTexBlockMaxWidth}
          mt={1.5}
          color="text.secondary"
        >
          {service.description}
        </Typography>
      </Box>
      <Box flex={1}>
        {service.services?.map((service) => (
          <Typography key={service} variant="h6" color="text.secondary">
            {service}
          </Typography>
        ))}
        {service.servicesWithindustry?.map((service, index) => (
          <Box key={service.industry} mt={index !== 0 ? 3 : 0}>
            <Typography
              component="p"
              variant="overline"
              color="text.secondary"
              mb={1.5}
            >
              {service.industry}
            </Typography>
            <Stack>
              {service.services?.map((service) => (
                <Typography key={service} variant="h6" color="text.secondary">
                  {service}
                </Typography>
              ))}
            </Stack>
          </Box>
        ))}
      </Box>
    </TextSectionWrapper>
  );
};

export default ServicesTextSection;
